import { Navigate, useNavigate } from "react-router-dom";
import CommonCard from "../ui/CommonCard/CommonCard";
import classes from "./CreatorMode.module.css";
import { useEffect, useState } from "react";

const jsonString = localStorage.getItem("formioUser");

const CreatorMode = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("")

  useEffect(() => {
     const user = JSON.parse(jsonString);
     setUserEmail(user?.data?.email)
  },[jsonString])

 

  const handleLogout = () => {
    localStorage.clear();
    // Navigate to login and replace the history entry
    navigate("/login", { replace: true });
  };

  return (
    <div className={classes.wrapper}>
      <h5>My account</h5>
      <CommonCard className={classes.customCard}>
        <div className={classes.welcomeContainer}>
          <h4>Welcome</h4>
          <h6>{userEmail}</h6>
        </div>
        <div className={classes.logoutContainer}>
          <h4 role="button" onClick={handleLogout}>
            Logout
          </h4>
        </div>
      </CommonCard>
    </div>
  );
};

export default CreatorMode;
